import React from 'react'
import * as firebase from 'firebase'
import { connect } from 'react-redux'
import MapView from './MapView'
import BottomBar from './BottomBar'

class MapController extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      withAddress: {},
      withoutAddress: {}
    }
    this.subscriptions = {}
    this.listeners = {}
    this.eventData = {}
  }

  componentWillMount() {
    const newEvents = this.getEvents(
      this.props.dateStr,
      this.props.selectedWorkers,
      this.props.instances
    )
    this.subscribeToEvents( newEvents )
  }

  componentWillReceiveProps(nextProps){
    if (this.props.dateStr !== nextProps.dateStr
      || this.props.instances !== nextProps.instances
      || this.props.selectedWorkers !== nextProps.selectedWorkers) {

      //1. get old events
      const thisEvents = this.getEvents(
        this.props.dateStr,
        this.props.selectedWorkers,
        this.props.instances
      )

      //2. get new events
      const nextEvents = this.getEvents(
        nextProps.dateStr,
        nextProps.selectedWorkers,
        nextProps.instances
      )

      //3. getEventsDifference
      const { oldEvents, newEvents } = this.getEventsDifference(thisEvents, nextEvents)

      //4. unsubscribe to unused events
      this.unsubscribeToEvents( oldEvents )

      //5. subscribe to new events
      this.subscribeToEvents( newEvents )
    }
  }

  componentWillUnmount(){
    const oldEvents = this.getEvents(
      this.props.dateStr,
      this.props.selectedWorkers,
      this.props.instances
    )
    this.unsubscribeToEvents( oldEvents )
  }

  getEvents = (dateStr, workers, calendarInstances) => {
    const allEvents = {}
    if (workers){
      workers.forEach(worker => {
        const userId = worker.userId
        const calInstanceId = `${userId}@${worker.teamId}->${dateStr}`
        const events = calendarInstances[calInstanceId]
        if (events){
          events.forEach(e => allEvents[e.eventId] = e)
        }
      })
    }
    return allEvents
  }

  getEventsDifference = (thisEvents, nextEvents) => {
    const oldEvents = Object
                       .keys(thisEvents)
                       .filter(eventId => !nextEvents.hasOwnProperty(eventId) )
                       .reduce((allEvents, eventId) => {
                         allEvents[eventId] = thisEvents[eventId]
                         return allEvents
                        }, {})
    const newEvents = Object
                       .keys(nextEvents)
                       .filter(eventId => !thisEvents.hasOwnProperty(eventId) )
                       .reduce((allEvents, eventId) => {
                         allEvents[eventId] = nextEvents[eventId]
                         return allEvents
                        }, {})
    return { oldEvents, newEvents }
  }

  subscribeToEvents = (events) => {
    Object
    .keys(events)
    .forEach(eventId => {
      if (!this.subscriptions[eventId]){
        const dbPath = `events/${eventId}`
        this.listeners[eventId] = this.onUpdate.bind(this, eventId)
        firebase.database().ref(dbPath).on('value', this.listeners[eventId])
        this.subscriptions[eventId] = true
      }
    })
  }

  unsubscribeToEvents = (events) => {
    Object
    .keys(events)
    .forEach(eventId => {
      if (this.subscriptions[eventId]){
        const dbPath = `events/${eventId}`
        firebase.database().ref(dbPath).off('value', this.listeners[eventId])
        this.subscriptions[eventId] = false;
        //for async compatibility, solving race condition
        //https://reactjs.org/docs/react-component.html#setstate
        this.setState(
          this.onRemove.bind(null, eventId)
        )
      }
    })
  }

  onUpdate(eventId, snapshot) {
    let eventInfo = snapshot.val()
    const type = this.getMapType(eventInfo)
    //for async compatibility, solving race condition
    //https://reactjs.org/docs/react-component.html#setstate
    this.setState(
      this.onAdd.bind(this, eventId, eventInfo, type)
    )
  }

  onAdd(eventId, eventInfo, type, prevState){
    let { withAddress, withoutAddress } = prevState
    withAddress = Object.assign({}, withAddress)
    withoutAddress = Object.assign({}, withoutAddress)
    switch(type){
      case 'address':
        withAddress[eventId] = true
        //remove if event had no address before
        if (withoutAddress[eventId]){
          delete withoutAddress[eventId]
        }
        this.eventData[eventId] = eventInfo
        break
      case 'noAddress':
        withoutAddress[eventId] = true
        //remove if event had address before
        if (withAddress[eventId]){
          delete withAddress[eventId]
        }
        this.eventData[eventId] = eventInfo
        break
    }
    return { withoutAddress, withAddress }
  }

  onRemove(eventId, prevState){
    let { withAddress, withoutAddress } = prevState
    if (withAddress.hasOwnProperty(eventId)){
      withAddress = Object.assign({}, withAddress)
      delete withAddress[eventId]
      return { withAddress }
    } else if (withoutAddress.hasOwnProperty(eventId)){
      withoutAddress = Object.assign({}, withoutAddress)
      delete withoutAddress[eventId]
      return { withoutAddress }
    }
  }

  getMapType(eventInfo){
    const addressModule = eventInfo.commonInfo.modules.address
    if (addressModule.hasOwnProperty('lat')
      && addressModule['lat']){
      return 'address'
    } else {
      return 'noAddress'
    }
  }

  render() {
    return (
      <div
        style={{ display: 'flex', flexDirection: 'column', flexGrow: 1}}>
        <div style={{display: 'flex', flexGrow: 1}}>
          <MapView
            eventIds={this.state.withAddress}
            eventInfos={this.eventData}
            dateStr={this.props.dateStr}/>
        </div>
        <div style={{ display: 'flex', position: 'relative' }}>
          <BottomBar
            eventIds={this.state.withoutAddress}
            eventInfos={this.eventData}
            dateStr={this.props.dateStr}/>
        </div>
      </div>
    )
  }
}

export default connect(state => ({ instances: state.schedule.instances }))(MapController)



// WEBPACK FOOTER //
// ./src/schedule/map/MapController.js